import React from "react";

export default function BackgroundOrbs({BRAND})
{
	return (
		<>
			<StyleBlock BRAND={BRAND}/>

			<div className="bg-orbs" aria-hidden="true">
				<div className="orb orb-a"/>
				<div className="orb orb-b"/>
				<div className="orb orb-c"/>
			</div>
		</>
	);
}

function StyleBlock({BRAND})
{
	return (
		<style>
			{`
				.bg-orbs {
					position: fixed;
					inset: 0;
					overflow: hidden;
					pointer-events: none;
					z-index: 0;
				}
				
				.orb {
					position: absolute;
					filter: blur(40px);
					opacity: 0.45;
					mix-blend-mode: multiply;
					border-radius: 50%;
				}
				
				.orb-a {
					width: 520px;
					height: 520px;
					left: -120px;
					top: -120px;
					background: radial-gradient(circle at 30% 30%, ${BRAND.primary}, #ff9a9e);
					animation: floaty-a 10s ease-in-out infinite alternate;
				}
				
				.orb-b {
					width: 460px;
					height: 460px;
					right: -160px;
					top: 20%;
					background: radial-gradient(circle at 70% 40%, ${BRAND.dark}, #888);
					animation: floaty-b 9s ease-in-out infinite alternate;
				}
				
				.orb-c {
					width: 380px;
					height: 380px;
					left: 20%;
					bottom: -140px;
					background: radial-gradient(circle at 50% 50%, #ff6b6b, ${BRAND.primary});
					animation: floaty-c 9s ease-in-out infinite alternate;
				}
				
				@keyframes floaty-a {
					0% {
						transform: translate3d(0, 0, 0) scale(1);
					}
					100% {
						transform: translate3d(200px, -200px, 0) scale(1.2);
					}
				}
				
				@keyframes floaty-b {
					0% {
						transform: translate3d(0, 0, 0) scale(1);
					}
					100% {
						transform: translate3d(-200px, -200px, 0) scale(1.2);
					}
				}
				
				@keyframes floaty-c {
					0% {
						transform: translate3d(0, 0, 0) scale(1);
					}
					100% {
						transform: translate3d(200px, -200px, 0) scale(1.2);
					}
				}
				
				@media (prefers-reduced-motion: reduce) {
					.orb {
						animation: none;
					}
				}
			`}
		</style>
	);
}
